import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-icon-check',
  templateUrl: './icon-check.component.html',
  styleUrls: ['./icon-check.component.scss']
})
export class IconCheckComponent implements OnInit {
  @Input() color: string = '#262628';
  @Input() size: number = 18;

  constructor() { }

  ngOnInit() {
  }

}
